import { render, staticRenderFns } from "./courseunitinfolist.vue?vue&type=template&id=0522d3f8&scoped=true"
import script from "./courseunitinfolist.vue?vue&type=script&lang=js"
export * from "./courseunitinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0522d3f8",
  null
  
)

export default component.exports